// extracted by mini-css-extract-plugin
export default {"PickUpTypes":"PickUpType_PickUpTypes__YzYyY","PickUpTypes__empty":"PickUpType_PickUpTypes__empty__YTY2Z","Tag":"PickUpType_Tag__YTA0Z","Tag__icon":"PickUpType_Tag__icon__YWU0M"};